import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import DocumentationLink from "components/support/DocumentationLink";
import { ExternalLink } from "components/common";
import useRunsWithDataNode from "components/datanode/hooks/useRunsWithDataNode";
import { WARM_TIER_DOCS, OPENSEARCH_CREATE_REPOSITORY_DOCS_URL } from "./constants";
const NODE_ROLES_SETTING = "node.roles";
const OPENSEARCH_CONFIG_FILE = "opensearch.yml";
const SEARCH_ROLE = "search";
const WARM_ROLE = "warm";
const DataNodeSteps = () => {
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement("ol", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "checklist.data_node.assign_search_role",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: WARM_TIER_DOCS.setupDataNode, text: t("checklist.documentation"), displayIcon: true })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("checklist.cache_size")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "checklist.data_node.setup_repository",
      components: {
        docsLink: /* @__PURE__ */ React.createElement(DocumentationLink, { page: WARM_TIER_DOCS.setupDataNode, text: t("checklist.snapshot_repository") })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("checklist.data_node.restart")), /* @__PURE__ */ React.createElement("li", null, t("checklist.repository_backend")));
};
const OpenSearchSteps = () => {
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement("ol", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "checklist.opensearch.assign_search_role",
      values: {
        node_roles: NODE_ROLES_SETTING,
        config_file: OPENSEARCH_CONFIG_FILE,
        search_role: SEARCH_ROLE,
        warm_role: WARM_ROLE
      },
      components: {
        code: /* @__PURE__ */ React.createElement("code", null),
        docsLink: /* @__PURE__ */ React.createElement(
          DocumentationLink,
          {
            page: WARM_TIER_DOCS.setupOpenSearch,
            text: t("checklist.documentation"),
            displayIcon: true
          }
        )
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("checklist.cache_size")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "checklist.opensearch.setup_repository",
      components: { repoLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: OPENSEARCH_CREATE_REPOSITORY_DOCS_URL }) }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("checklist.opensearch.restart")), /* @__PURE__ */ React.createElement("li", null, t("checklist.repository_backend")));
};
const SetupChecklistSteps = () => {
  const { data: runsWithDataNode } = useRunsWithDataNode();
  return runsWithDataNode ? /* @__PURE__ */ React.createElement(DataNodeSteps, null) : /* @__PURE__ */ React.createElement(OpenSearchSteps, null);
};
export default SetupChecklistSteps;
